/* eslint-disable no-restricted-imports */
/* eslint-disable no-restricted-globals */
import { settings } from "@/settings";
import Cookies from "js-cookie";

export default class Store {
    private _type: "session" | "local" | "cookie";

    /**
     * Creates storage object to access and store values
     * @param type type of storage to be used
     */
    constructor(type: "session" | "local" | "cookie" = "session") {
        this._type = type;
    }

    /**
     * Sets value to storage
     * @param name Value name used as identifier
     * @param value Value to be stored
     */
    set<T = any>(name: string, value: T, options?: any): void {
        let stringValue: string = value as string;
        if (typeof value == "object") {
            stringValue = JSON.stringify(value);
        }

        switch (this._type) {
            case "session":
                this.setToSession(name, stringValue);
                break;
            case "local":
                this.setToLocal(name, stringValue);
                break;
            case "cookie":
                this.setToCookie(name, stringValue, options);
                break;
        }
    }

    /**
     * Gets value from storage
     *
     * @param name Name of value
     */
    get<T = any>(name: string): T {
        let val = null;
        switch (this._type) {
            case "session":
                val = this.getFromSession(name);
                break;
            case "local":
                val = this.getFromLocal(name);
                break;
            case "cookie":
                val = this.getFromCookie(name);
                break;
        }

        if (val) {
            try {
                return JSON.parse(val) as T;
            } catch (ex: unknown) {
                return val as T;
            }
        }

        return val;
    }

    /**
     * Removes value from storage
     *
     * @param name name of value
     */
    remove(name: string, options?: any): void {
        switch (this._type) {
            case "session":
                this.removeFromSession(name);
                break;
            case "local":
                this.removeFromLocal(name);
                break;
            case "cookie":
                this.removeFromCookie(name, options);
                break;
        }
    }

    //#region Set
    private setToSession(name: string, value: string) {
        sessionStorage.setItem(name, value);
    }

    private setToLocal(name: string, value: string) {
        localStorage.setItem(name, value);
    }

    private setToCookie(name: string, value: string, options?: any) {
        Cookies.set(name, value, { ...{ path: settings.url.root, secure: true }, ...options });
    }
    //#endregion

    //#region Get
    private getFromSession(name: string): string {
        return sessionStorage.getItem(name);
    }

    private getFromLocal(name: string): string {
        return localStorage.getItem(name);
    }

    private getFromCookie(name: string): string {
        return Cookies.get(name);
    }
    //#endregion

    //#region Remove
    private removeFromSession(name: string): void {
        sessionStorage.removeItem(name);
    }

    private removeFromLocal(name: string): void {
        localStorage.removeItem(name);
    }

    private removeFromCookie(name: string, options?: any): void {
        Cookies.remove(name, { ...{ path: settings.url.root }, ...options });
    }
    //#endregion
}
